import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Paginator from '../paginator';
import { apiurl } from '../../utils/constants';
import { fCurr, getInvoiceStatusInfo, getDaysUntilDue } from '../../utils/functions';
import { ExportToExcel } from '../../utils/exportxlsx';
import ReloadButton from '../../utils/reload';


function ListLInvoice({ onMenuItemClick, filtr }) {

	// Calcula fecha de hace 6 meses, primer día del mes
	const getDateSixMonthsAgo = () => {
		const today = new Date();
		const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 6, 1);
		const year = sixMonthsAgo.getFullYear();
		const month = String(sixMonthsAgo.getMonth() + 1).padStart(2, '0');
		return `${year}-${month}-01`;
	};

	const [invoices, setInvoices] = useState([]);
	const [excelData, setExcelData] = useState([]);
	const { iden: iuser, mail, sapDB, budg, sap_user } = useSelector((state) => state.user);

	const [paginatedInvoice, setPaginatedInvoice] = useState([]);
	const [totalFiltered, setTotalFiltered] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [cc, setCC] = useState([]);
	const [acco, setAcco] = useState([]);
	const [filtBeat, setFiltBeat] = useState(false);
	const [filtBill, setFiltBill] = useState(false);
	const [filtPendBill, setFiltPendBill] = useState(false);
	const [filtPendBillCC, setFiltPendBillCC] = useState(false);
	const [filtCode, setFiltCode] = useState('');
	const [filtCodeAF, setFiltCodeAF] = useState('');
	const [filtCC, setFiltCC] = useState('');
	const [filtAccount, setFiltAccount] = useState('');
	const [filtStat, setFiltStat] = useState('');
	const [filtCardName, setFiltCardName] = useState('');
	const [filtDocDateStart, setFiltDocDateStart] = useState(getDateSixMonthsAgo());
	const [filtDocDateEnd, setFiltDocDateEnd] = useState('');
	const [filtU_NAME, setFiltU_NAME] = useState('');
	const [filtTaxDateStart, setFiltTaxDateStart] = useState('');
	const [filtTaxDateEnd, setFiltTaxDateEnd] = useState('');
	const [filtApprover, setFiltApprover] = useState('');
	const [filtApproDateStart, setFiltApproDateStart] = useState('');
	const [filtApproDateEnd, setFiltApproDateEnd] = useState('');
	const [filtDocDueDateStart, setFiltDocDueDateStart] = useState('');
	const [filtDocDueDateEnd, setFiltDocDueDateEnd] = useState('');
	const [filtReqAppr, setFiltReqAppr] = useState(true);
	const [filtNotReqAppr, setFiltNotReqAppr] = useState(true);
	const [countBeat, setCountBeat] = useState(0);
	const [filteredTotal, setFilteredTotal] = useState(0);
	const currentUrl = window.location.href;

	const itemsPerPage = 10;


	const loadInvoices = useCallback(async () => {
		try {
			const response = await fetch(apiurl + `invoices`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, user: mail, budg, iuser, initDate: filtDocDateStart
				})
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			console.log(data);
			setInvoices(Array.isArray(data) ? data : []);

		} catch (error) {
			console.error('Error fetching invoices:', error);
		}
	}, [budg, iuser, mail, sapDB, filtDocDateStart]);

	useEffect(() => {
		if (!Array.isArray(invoices)) return;

		const now = new Date();
		const count = invoices.filter(inv => {
			if (!inv.DocDueDate || inv.Cancelled === 'C' || !inv.requested || (inv.DocTotal === inv.PaidToDate)) return false;
			const due = new Date(inv.DocDueDate);
			const diffDays = Math.ceil((due - now) / (1000 * 60 * 60 * 24));
			return diffDays >= 0 && diffDays <= 7;
		}).length;

		setCountBeat(count);
	}, [invoices]);

	useEffect(()=>{
		if (filtr) {
			if (filtr.fiiltCode !== undefined) setFiltCode(filtr.fiiltCode);
			if (filtr.filtCardName !== undefined) setFiltCardName(filtr.filtCardName);
			if (filtr.filtCC !== undefined) setFiltCC(filtr.filtCC);
			if (filtr.filtDocDateStart !== undefined) setFiltDocDateStart(filtr.filtDocDateStart);
			if (filtr.filtU_NAME !== undefined) setFiltU_NAME(filtr.filtU_NAME);
			if (filtr.filtStat !== undefined) setFiltStat(filtr.filtStat);
			if (filtr.filtTaxDateStart !== undefined) setFiltTaxDateStart(filtr.filtTaxDateStart);
			if (filtr.filtTaxDateEnd !== undefined) setFiltTaxDateEnd(filtr.filtTaxDateEnd);
			if (filtr.filtApprover !== undefined) setFiltApprover(filtr.filtApprover);
			if (filtr.filtApproDateStart !== undefined) setFiltApproDateStart(filtr.filtApproDateStart);
			if (filtr.filtApproDateEnd !== undefined) setFiltApproDateEnd(filtr.filtApproDateEnd);
			if (filtr.filtDocDueDateStart !== undefined) setFiltDocDueDateStart(filtr.filtDocDueDateStart);
			if (filtr.filtDocDueDateEnd !== undefined) setFiltDocDueDateEnd(filtr.filtDocDueDateEnd);
		}
	}, [filtr])

	const loadListCC = useCallback(async () => {

		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					query: `SELECT code, name FROM req__cent;`
				}),
				credentials: 'include'
			});

			if (response.ok) {
				const data = await response.json();

				// Almacena todos los CC del sistema con code y name en setCC
				const formattedData = data.map(item => ({ code: item.code, name: item.name }));
				setCC(formattedData);

			} else {
				console.error('Error al obtener los CC');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}

	}, [mail])

	const loadListAcco = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					query: `SELECT code, name FROM inv__acco;`
				}),
				credentials: 'include'
			});

			if (response.ok) {
				const data = await response.json();
				setAcco(data.map(item => ({ code: item.code, name: item.name })));
			} else {
				console.error('Error al obtener las cuentas');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	}, [mail])

	const providers = useMemo(() => {
		const map = new Map();
		invoices.forEach(inv => { if (inv.CardCode && !map.has(inv.CardCode)) map.set(inv.CardCode, inv.CardName); });
		return Array.from(map, ([code, name]) => ({ code, name }));
	}, [invoices]);

	useEffect(() => {
		loadListCC();
		loadListAcco();
		loadInvoices();
	}, [loadInvoices, loadListCC, loadListAcco]);

	const filtCCMatch = cc.find(c => c.name === filtCC || String(c.code) === filtCC);
	const filtAccountMatch = acco.find(a => a.name === filtAccount || String(a.code) === filtAccount);
	const filtProvMatch = providers.find(p => p.name === filtCardName || String(p.code) === filtCardName);

	useEffect(() => {
		const filteredData = invoices?.filter(bill => {

			const matchesBeat = !filtBeat || (() => {
				if (!bill.DocDueDate) return false;
				if (!bill.requested) return false;
				if (bill.DocTotal === bill.PaidToDate) return false;
				const now = new Date();
				const due = new Date(bill.DocDueDate);
				const diffDays = Math.ceil((due - now) / (1000 * 60 * 60 * 24));
				return diffDays >= 0 && diffDays <= 7;
			})();

			const matchesCode = !filtCode || String(bill.FolioPref + "-" + bill.FolioNum).toLowerCase().includes(filtCode.toLowerCase());
			const matchesCodeAF = !filtCodeAF ||
				(Array.isArray(bill.items) &&
					bill.items.some(item =>
						String(item.ActivoFijo || '').toLowerCase().includes(filtCodeAF.toLowerCase())
					)
				);
			const matchesCC = !filtCC || (filtCCMatch
				? String(bill.cent) === String(filtCCMatch.code)
				: (String(bill.cent ?? '').toLowerCase().includes(filtCC.toLowerCase()) || String(bill.cc_name ?? '').toLowerCase().includes(filtCC.toLowerCase())));
			const matchesAccount = !filtAccount ||
				(Array.isArray(bill.items) &&
					bill.items.some(item => filtAccountMatch
						? String(item.AccountCode || '') === String(filtAccountMatch.code)
						: (String(item.AccountCode ?? '').toLowerCase().includes(filtAccount.toLowerCase()) || String(item.AccountName ?? '').toLowerCase().includes(filtAccount.toLowerCase()))
					)
				);
			const matchesStat = !filtStat || bill.DocumentStatus === filtStat;

			const matchesCodeName = !filtCardName || (filtProvMatch
				? String(bill.CardCode) === String(filtProvMatch.code)
				: (String(bill.CardCode ?? '').toLowerCase().includes(filtCardName.toLowerCase()) || String(bill.CardName ?? '').toLowerCase().includes(filtCardName.toLowerCase())));
			const matchesStartDate = !filtDocDateStart || !bill.DocDate || (bill.DocDate.slice(0, 10) >= filtDocDateStart);
			const matchesEndDate = !filtDocDateEnd || !bill.DocDate || (bill.DocDate.slice(0, 10) <= filtDocDateEnd);

			const matchesU_NAME = !filtU_NAME || (bill.U_NAME && bill.U_NAME.toLowerCase().includes(filtU_NAME.toLowerCase()));
			const matchesTaxDateStart = !filtTaxDateStart || (bill.TaxDate && bill.TaxDate.slice(0, 10) >= filtTaxDateStart);
			const matchesTaxDateEnd = !filtTaxDateEnd || (bill.TaxDate && bill.TaxDate.slice(0, 10) <= filtTaxDateEnd);

			const matchesApprover = !filtApprover ||
				(bill.cc_name_user && bill.cc_name_user.toLowerCase().includes(filtApprover.toLowerCase())) ||
				(bill.name_approver && bill.name_approver.toLowerCase().includes(filtApprover.toLowerCase()));

			const matchesApproDateStart = !filtApproDateStart || (bill.approved && bill.Cancelled === 'N' && bill.approved.slice(0, 10) >= filtApproDateStart);
			const matchesApproDateEnd = !filtApproDateEnd || (bill.approved && bill.Cancelled === 'N' && bill.approved.slice(0, 10) <= filtApproDateEnd);

			const matchesDocDueDateStart = !filtDocDueDateStart || (bill.DocDueDate && bill.DocDueDate.slice(0, 10) >= filtDocDueDateStart && bill.Cancelled === 'N' && bill.DocTotal !== bill.PaidToDate);
			const matchesDocDueDateEnd = !filtDocDueDateEnd || (bill.DocDueDate && bill.DocDueDate.slice(0, 10) <= filtDocDueDateEnd && bill.Cancelled === 'N' && bill.DocTotal !== bill.PaidToDate);

			const matchesReqNotReqAppr =
				(filtReqAppr && filtNotReqAppr) // ambos tildados, mostrar todas
				|| (filtReqAppr && bill.approver !== 6) // solo requiere aprobación
				|| (filtNotReqAppr && bill.approver === 6); // solo no requiere aprobación

			const billMatches = !filtBill || (bill.U_CODE === sap_user);
			const pendBillMatches = !filtPendBill || (bill.U_CODE === sap_user && !bill.approved);
			const pendBillCCMatches = !filtPendBillCC || (bill.cc_mail_user === mail && !bill.approver);

			// Si estado es emitida, entonces se muestra solo a los contadores.
			const isEmitted = !bill.entry;
			const emittedVisibilityMatches = !isEmitted || Boolean(budg);

			return matchesBeat && matchesCode && matchesCodeAF && matchesCC && matchesAccount && matchesStat
				&& matchesCodeName && matchesStartDate && matchesEndDate
				&& matchesU_NAME && matchesTaxDateStart && matchesTaxDateEnd
				&& matchesApprover && matchesApproDateStart && matchesApproDateEnd
				&& matchesDocDueDateStart && matchesDocDueDateEnd
				&& matchesReqNotReqAppr
				&& billMatches && pendBillCCMatches && pendBillMatches
				&& emittedVisibilityMatches;

		})

		const pageHasData = (filteredData?.length || 0) > (currentPage - 1) * itemsPerPage;
		const pageToUse = pageHasData ? currentPage : 1;
		if (pageToUse !== currentPage) setCurrentPage(pageToUse);

		const startIndex = (pageToUse - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;

		const total = filteredData?.reduce((acc, curr) => acc + (Number(curr.DocTotal) || 0), 0) || 0;
		setFilteredTotal(total);

		const excelRows = filteredData?.map(inv => ({
			'Folio': inv.FolioNum,
			'Generada': inv.TaxDate ? inv.TaxDate.slice(0, 10).split('-').reverse().join('/') : '',
			'Rut del proveedor': inv.CardCode,
			'Nombre del Proveedor': inv.CardName,
			'Centro de costo': inv.cc_name,
			'Contabilizada': inv.DocDate ? inv.DocDate.slice(0, 10).split('-').reverse().join('/') : '',
			'Contador': inv.U_NAME,
			'Estado': getInvoiceStatusInfo(inv.DocumentStatus).title,
			'Publicado': inv.requested ? inv.requested.slice(0, 10).split('-').reverse().join('/') : '',
			'Aprobada': inv.approved ? inv.approved.slice(0, 10).split('-').reverse().join('/') : '',
			'Aprobador': inv.name_approver || '',
			'Vencimiento': inv.DocDueDate ? inv.DocDueDate.slice(0, 10).split('-').reverse().join('/') : '',
			'Pagada': inv.UpdateDate && (inv.DocTotal === inv.PaidToDate) ? (inv.UpdateDate.slice(0, 10).split('-').reverse().join('/')) : '',
			'Costo': (inv.DocTotal),
			'Comentario': inv.private_comment
		})) || [];
		setExcelData(excelRows);

		if (Array.isArray(filteredData) && filteredData.length > 0) {
			console.log({ filteredData });
			setPaginatedInvoice(filteredData.slice(startIndex, endIndex));
			setTotalFiltered(filteredData.length);
		} else {
			setPaginatedInvoice([]);
			setTotalFiltered(0);
		}

	}, [invoices, currentPage, filtBeat, filtCode, filtCodeAF, filtCC, filtCCMatch, filtAccount, filtAccountMatch, filtStat,
		filtCardName, filtProvMatch, filtDocDateStart, filtDocDateEnd,
		filtU_NAME, filtTaxDateStart, filtTaxDateEnd,
		filtApprover, filtApproDateStart, filtApproDateEnd,
		filtDocDueDateStart, filtDocDueDateEnd,
		filtReqAppr, filtNotReqAppr,
		filtBill, filtPendBill, filtPendBillCC, budg, mail, sap_user]);

	return (
		<>
			<form>
				<style jsx="true" > {`.itemTable .ellipsis{ max-width: 400px; }`} </style>
				<main>
					<h1 data-icon=''>Facturas</h1>
					<nav>
						{
							paginatedInvoice.map((invoice) => (
								<article onClick={() => {
									console.log(invoice);
									console.log({ component:'listInvoDeta', docu:invoice.docu, iden:invoice.iden_form});
									onMenuItemClick({ component:'listInvoDeta', docu:invoice.docu, iden:invoice.iden_form,
										filtr: {
											fiiltCode: String(filtCode),
											filtCardName: String(filtCardName),
											filtCC: String(filtCC),
											filtDocDateStart: String(filtDocDateStart),
											filtU_NAME: String(filtU_NAME),
											filtStat: String(filtStat),
											filtTaxDateStart: String(filtTaxDateStart),
											filtTaxDateEnd: String(filtTaxDateEnd),
											filtApprover: String(filtApprover),
											filtApproDateStart: String(filtApproDateStart),
											filtApproDateEnd: String(filtApproDateEnd),
											filtDocDueDateStart: String(filtDocDueDateStart),
											filtDocDueDateEnd: String(filtDocDueDateEnd),
										}
									})
								}} key={invoice.iden_form}>
									<div>
										<h2>
											<div>{invoice.CardCode} {invoice.CardName}</div>
											<div>{invoice.cc_name ? `${invoice.cent}. ${invoice.cc_name}` : '-'}</div>
											<div>
												{invoice.DocDate
													? invoice.DocDate.slice(0, 10).split('-').reverse().join('/')
													: invoice.entry ? '--/--/----' : '-'
												}
											</div>
										</h2>
									</div>

									<table className='requestTable'>
										<tbody>
											<tr>
												<th title={invoice.docu}>{invoice.FolioNum ? `${invoice.FolioPref}-` : ''}{invoice.FolioNum ?? '-'} </th>
												<td>
													<table className='itemTable' >
														<tbody>
															{
																invoice.items && invoice.items.map((item, idx) => (
																	<tr key={item.id__ || idx}>
																		<td>{item.ItemCode ?? `C:${item.AccountCode}`}</td>
																		<td className='ellipsis'>{item.ItemCode ? item.Dscription : item.AccountName}</td>
																		<td>{fCurr(item.Quantity)}</td>
																	</tr>
																))
															}
														</tbody>
													</table>
												</td>
												<th> {fCurr(invoice.DocTotal)} CLP </th>
												{
													invoice.DocTotal === invoice.PaidToDate ? (<td></td>) : (
														<td className={`state expire 
														${getDaysUntilDue(invoice.DocDueDate) <= 7 && getDaysUntilDue(invoice.DocDueDate) >= 1
																? 'ora'
																: (getDaysUntilDue(invoice.DocDueDate) < 1 ? 'red' : '')
															}`}>
															
															{invoice.DocDueDate && invoice.DocDueDate !== '1970-01-01' ?
															<>
															{
																invoice.entry ?
																<>
																<h3>Vencimiento:</h3>
																<time>{invoice.DocDueDate.slice(0, 10).split('-').reverse().join('/')}</time>
																<div>
																	{getDaysUntilDue(invoice.DocDueDate) < 1 ? `Vencido` : `Quedan ${getDaysUntilDue(invoice.DocDueDate)} días`}
																</div>
																</>
																: <span></span>
															}
															</> : '-'
															}
														</td>
													)
												}
												<td className={`state ${getInvoiceStatusInfo(invoice.DocumentStatus).color}`}>
													<mark>{getInvoiceStatusInfo(invoice.DocumentStatus).title}</mark>
													{invoice?.name_approver && ['Approved', 'Rejected'].includes(invoice?.DocumentStatus) ? <time>Por {invoice.name_approver}</time> : <></>}
													{
														!invoice.docu && !invoice.entry ?
														<></> :
														<time>
															{invoice?.approved
																? invoice.approved.slice(0, 10).split('-').reverse().join('/')
																: (invoice.UpdateDate
																	? invoice.UpdateDate.slice(0, 10).split('-').reverse().join('/')
																	: '--/--/----')}
														</time>
													}
												</td>
											</tr>
										</tbody>
									</table>

								</article>
							))
						}
					</nav>
					<nav>
						<article>
							<Paginator totalItems={totalFiltered} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={setCurrentPage} tdAux={`${fCurr(filteredTotal)} CLP`} />
						</article>
					</nav>
				</main>
				<aside>
					<article>
						<h2>Acciones</h2>
						<fieldset>
							<ReloadButton onReload={loadInvoices} />
							<ExportToExcel apiData={excelData} fileName={"Libro de compra"} />
							<input type="button" value="Ver estadísticas" onClick={() => onMenuItemClick('listStatInvoice')} />
						</fieldset>
					</article>
					<article>
						<h2>Advertencias</h2>
						<fieldset>
							<a href={currentUrl} className={filtBeat ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltBeat(!filtBeat); }}> Por vencer ({countBeat}) <orm-icon class="ora"></orm-icon></a>
						</fieldset>
					</article>
					{
						budg ?
							<article>
								<h2>Atajos</h2>
								<fieldset>
									{ sap_user ?
									(<>
										<a href={currentUrl} className={filtBill ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltBill(!filtBill); }}> Mis facturas </a>
										<a href={currentUrl} className={filtPendBill ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltPendBill(!filtPendBill); }}> Mis facturas pendientes</a>
									</>) : <a href={currentUrl} className={filtPendBillCC ? 'active' : null} onClick={(e) => { e.preventDefault(); setFiltPendBillCC(!filtPendBillCC); }}> Mis facturas por aprobar</a>
									}
									
								</fieldset>
							</article> : <></>
					}
					<article>
						<h2>Filtros</h2>
						<fieldset>
							<legend>Información </legend>
							<input type="search" placeholder="Folio" value={filtCode} onChange={e => { setFiltCode(e.target.value); }} />
							<input type="search" placeholder="Activo Fijo" value={filtCodeAF} onChange={e => { setFiltCodeAF(e.target.value); }} />
							<input type="search" placeholder="Centro de costos" list="cent" value={filtCC} onChange={e => setFiltCC(e.target.value)} />
							<datalist id="cent"> {cc
								.slice()
								.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
								.map((c) => (
									<option key={c.code} value={c.code}>{c.name}</option>
								))}
							</datalist>
							<input type="search" placeholder="Cuenta" list="accounts" value={filtAccount} onChange={e => setFiltAccount(e.target.value)} />
							<datalist id="accounts"> {acco
								.slice()
								.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
								.map((a) => (
									<option key={a.code} value={a.code}>{a.name}</option>
								))}
							</datalist>
							<select value={filtStat} onChange={e => { setFiltStat(e.target.value); }}>
								<option value=''> Estado </option>
								<option value='Issued'> Emitida </option>
								<option value='Draft'> Borrador </option>
								<option value='Posted'> Contabilizada </option>
								<option value='Rejected'> Rechazada </option>
								<option value='Approved'> Aprobada </option>
								<option value='Paid'> Pagada </option>
								<option value='Cancelled'> Cancelada </option>
								<option value='Closed'> Cerrada </option>
							</select>
						</fieldset>
						<fieldset>
							<legend>Emisión</legend>
							<input type="text" placeholder="Proveedor" list="providers" value={filtCardName} onChange={e => setFiltCardName(e.target.value)} />
							<datalist id="providers">
								{providers.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(p => (
									<option key={p.code} value={p.code}>{p.name}</option>
								))}
							</datalist>
							<input type="date" value={filtTaxDateStart} onChange={(e) => { setFiltTaxDateStart(e.target.value); }} />
							<input type="date" value={filtTaxDateEnd} onChange={(e) => { setFiltTaxDateEnd(e.target.value); }} />
						</fieldset>
						<fieldset>
							<legend>Contabilización</legend>
							<input type="text" placeholder="Responsable" value={filtU_NAME} onChange={e => { setFiltU_NAME(e.target.value); }} />
							<input type="date" value={filtDocDateStart} onChange={(e) => { setFiltDocDateStart(e.target.value); }} />
							<input type="date" value={filtDocDateEnd} onChange={(e) => { setFiltDocDateEnd(e.target.value); }} />
						</fieldset>
						<fieldset>
							<legend>Aprobación</legend>
							<input type="text" placeholder="Aprobador" value={filtApprover} onChange={e => { setFiltApprover(e.target.value); }} />

							<input id="reqAppr" type="checkbox" checked={filtReqAppr} onChange={e => { setFiltReqAppr(!filtReqAppr); }} />
							<label htmlFor="reqAppr"> Requiere aprobación</label>

							<input id="notReqAppr" type="checkbox" checked={filtNotReqAppr} onChange={e => { setFiltNotReqAppr(!filtNotReqAppr); }} />
							<label htmlFor="notReqAppr"> No requiere aprobación</label>

							<input type="date" value={filtApproDateStart} onChange={(e) => { setFiltApproDateStart(e.target.value); }} />
							<input type="date" value={filtApproDateEnd} onChange={(e) => { setFiltApproDateEnd(e.target.value); }} />
						</fieldset>
						<fieldset>
							<legend>Vencimiento</legend>
							<input type="date" value={filtDocDueDateStart} onChange={(e) => { setFiltDocDueDateStart(e.target.value); }} />
							<input type="date" value={filtDocDueDateEnd} onChange={(e) => { setFiltDocDueDateEnd(e.target.value); }} />
						</fieldset>
					</article>
				</aside>
			</form>
		</>
	);

}

export default ListLInvoice;
